import React, { Component } from 'react'
import Link from '../utils/link'

class Partnerships extends Component {

  render() {

    let { partnerships } = this.props

    return (
        <div className='partnerships'>

          <div className='partnerships__content'>

            { partnerships &&

              <div className='partnerships__items'>

                  { partnerships.map((el, i) => (

                      <div className='partnerships__item' key={i}>

                        <h4 className='heading' dangerouslySetInnerHTML={{ __html: el.title }} />

                        <div className='copy' dangerouslySetInnerHTML={{ __html: el.content }} />

                        { el.link &&
                          <span className='website'>{ el.text }</span>
                        }

                        { el.link && <Link className='link' to={el.link}></Link> }

                      </div>

                  ))}

              </div>

            }

          </div>
            
        </div>
    )
  }
}

export default Partnerships
